import { trackCustomerActivity } from '../api/customerActivity';
const changes = new Set(['CART_ADD_ITEM', 'CART_ADD_ITEM_WITH_ADDON', 'CART_REMOVE_ITEM', 'CART_REMOVE_ADDON_ITEM', 'CART_UPDATE_QUANTITIES', 'CART_UPDATE_QUANTITY', 'CART_EMPTY']);
const snapshot = items => items.slice(0, 30).map(item => ({ title: item.product?.title || 'Package', sku: item.product?.sku || '', quantity: item.quantity, total: item.total }));
const customerActivityMiddleware = store => next => action => {
  const before = store.getState().cart;
  const result = next(action);
  try {
    const after = store.getState().cart;
    if (changes.has(action.type) && after !== before && store.getState().auth?.isLogin) {
      const removed = (before?.items || []).filter(item => !(after?.items || []).some(current => current.id === item.id));
      if (action.type !== 'CART_EMPTY' && removed.length) trackCustomerActivity('Removed from Cart', { items: snapshot(removed), cartCount: after.items.length, amount: after.total });
      trackCustomerActivity('Cart updated', { items: snapshot(after.items || []), cartCount: (after.items || []).length, amount: after.total });
    }
  } catch (error) { /* Never change dispatch return values or shopping behavior. */ }
  return result;
};

export default customerActivityMiddleware;
